import { render } from "./MWPhotos.vue?vue&type=template&id=7f46e09c"
import script from "./MWPhotos.vue?vue&type=script&lang=js"
export * from "./MWPhotos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__